let currency = { code: "INR", locale: "en-IN" };

export function setCurrency(c) {
  if (c?.code) currency = c;
}

export function money(n, opts = {}) {
  const v = Number(n || 0);
  return new Intl.NumberFormat(currency.locale, {
    style: "currency", currency: currency.code, minimumFractionDigits: opts.whole ? 0 : 2, maximumFractionDigits: opts.whole ? 0 : 2,
  }).format(v);
}

export function dateTime(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function dateOnly(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
}

export function initials(name = "") {
  return name.split(" ").filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "U";
}
